import { Injectable } from '@angular/core';
import { Adapter } from '@app/core/adapter';
import { Country } from '@app/shared/models/country.model';

@Injectable()
export class CountryAdapter implements Adapter<Country> {
    adapt(data: any): Country {
        return {
            id: data.id || 0,
            code: data.alpha3?.toUpperCase() || '',
            name: data.name || '',
        } as Country;
    }
}
